import PropTypes from "prop-types";
import CalendarNavigation from "./CalendarNavigation";
import Cells from "./Cells";
import "./calendar.scss";
import dayjs from "dayjs";
import OccupancyInfoBanner from "../occupancy-banner/OccupancyInfoBanner";
import { usePropertyStore } from "../../contexts/PropertyStoreContext";

const Calendar = ({
  ariDataList,
  currentMonth,
  setCurrentMonth,
  selectedDateCell,
  setSelectedDateCell,
  showInfoIcon,
}) => {
  const { selectedProperty } = usePropertyStore();
  const propertyId = selectedProperty?.propertyId;

  return (
    <>
      {/* showInfoIcon is coerced because it is optional: left undefined it
          would fall through to defaultVisible's own default and show a banner
          where this component previously showed none. */}
      <OccupancyInfoBanner
        storageKey={`showInfoBanner_${propertyId}`}
        defaultVisible={Boolean(showInfoIcon)}
        placeholderClassName="info-banner-placeholder"
      />
      <div className="calendar container-fluid">
        <CalendarNavigation
          currentMonth={currentMonth}
          setCurrentMonth={setCurrentMonth}
        />
        <Cells
          ariDataList={ariDataList}
          currentMonth={currentMonth}
          selectedDateCell={selectedDateCell}
          setSelectedDateCell={setSelectedDateCell}
        />
      </div>
    </>
  );
};

Calendar.propTypes = {
  ariDataList: PropTypes.array,
  selectedDateCell: PropTypes.instanceOf(dayjs),
  setSelectedDateCell: PropTypes.func.isRequired,
  currentMonth: PropTypes.instanceOf(dayjs).isRequired,
  setCurrentMonth: PropTypes.func.isRequired,
  showInfoIcon: PropTypes.bool,
};

export default Calendar;
